module.exports = __webpack_public_path__ + "img/warm-up.00c3f7c8.jpg";